module.exports = __webpack_public_path__ + "r-v3/img/qna_white.ca77fd27.svg";